import { useState } from "react";

import AuditQuestionnaireContainer from "../AuditQuestionnaireContainer";
import AddQuestionnaireQuestionContent from "../AddQuestionnaireQuestionContent";
import variables from "../../themes/base/styles/variables";
import Style from "./AddQuestionnaireQuestionContainerStyle.module.scss";
import { getIsAudit } from "../../UtilityFunctions/utils";
import { EVALUATION_STATUS_CONSTANTS } from "../../constants";

const colorMap = {
  [EVALUATION_STATUS_CONSTANTS.NG]: variables.primaryBg,
  [EVALUATION_STATUS_CONSTANTS.OK]: variables.successGreen,
  [EVALUATION_STATUS_CONSTANTS.IMPROVEMENT]: variables.amberYellow,
  default: variables.grey4,
};

const AddQuestionnaireQuestionContainerStyle = {
  questionNodeDiv: {
    backgroundColor: variables.bodyBg,
    border: `1px solid ${variables.grey4}`,
    width: variables.treeDivWidthSmall,
    height: "fit-content",
    cursor: "default",
    marginTop: variables.marginSmall,
    display: "flex",
    flexDirection: "row",
  },
  dragIcon: {
    position: "absolute",
    top: -1,
    left: "50%",
    translate: "transform(-50%,-50%)",
    cursor: "pointer",
    width: variables.iconWidth,
  },
  draggableDivStyle: {
    width: variables.fullWidth,
    height: variables.fullHeight,
    padding: variables.paddingSmall,
  },
};
const AddQuestionnaireQuestionContainer = ({
  index,
  question,
  hasQuestion,
  questionsData,
  indexKey,
  addQuestionToSection,
  setQuestionsData,
  mode,
  evidenceInProgress,
  setEvidenceInProgress,
}) => {
  const [borderAlert, setBorderAlert] = useState(false);
  const sectionWrapper = document.getElementById(`section-wrapper${indexKey}`);

  const isQuestionnaire = window.location.href.includes("questionnaire");
  const isAudit = getIsAudit();

  function replaceQuestionsWithSwappedOnes(newQuestions) {
    const traverseAndUpdateQuestion = (sections) => {
      for (const section of sections) {
        if (section.sequence === indexKey) {
          if (section.questions) {
            section.questions = newQuestions;
            return;
          }
        }

        if (section.sections) {
          traverseAndUpdateQuestion(section.sections);
        }
      }
    };

    traverseAndUpdateQuestion(questionsData);
    setQuestionsData([...questionsData]);
  }

  const onDragStart = (evt, obj) => {
    evt.dataTransfer.effectAllowed = "move";

    evt.dataTransfer.setData("text/plain", JSON.stringify(obj));
  };

  const onDragEnter = (event, key) => {
    event.preventDefault();
    event.dataTransfer.effectAllowed = "move";
  };

  const onDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    sectionWrapper.style.maxHeight = "calc(100vh - 25rem)";
  };

  const onDragEnd = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    sectionWrapper.style.maxHeight = "none";
  };

  const onDrop = (event, droppedKeyObject) => {
    let draggedKeyObject =
      event?.dataTransfer?.getData("text/plain") &&
      JSON?.parse(event?.dataTransfer?.getData("text/plain"));
    if (
      draggedKeyObject.sequence !== droppedKeyObject.sequence &&
      draggedKeyObject.questionIndex === droppedKeyObject.questionIndex
    ) {
      let newQuestions = [...hasQuestion];
      const draggedItem = newQuestions.find(
        (questionItem) => questionItem.sequence === draggedKeyObject.sequence
      );
      const droppedItem = newQuestions.find(
        (questionItem) => questionItem.sequence === droppedKeyObject.sequence
      );
      if (draggedItem && droppedItem) {
        const temp = draggedItem.sequence;
        draggedItem.sequence = droppedItem.sequence;

        droppedItem.sequence = temp;
      }
      newQuestions.sort((a, b) => a.sequence - b.sequence);
      replaceQuestionsWithSwappedOnes(newQuestions);
    }
    sectionWrapper.style.maxHeight = "none";
  };

  const onSectionDrop = (e) =>
    hasQuestion?.length >= 2 &&
    onDrop(e, {
      sequence: question.sequence,
      questionIndex: indexKey,
    });

  const onSectionDropStart = (e) =>
    hasQuestion?.length >= 2 &&
    onDragStart(e, {
      sequence: question.sequence,
      questionIndex: indexKey,
    });

  return (
    <>
      <div
        className={`${Style["question-node"]}`} // keep this style for before and after
        key={question.sequence}
        id={`${indexKey}${question.sequence}`}
        style={{
          ...AddQuestionnaireQuestionContainerStyle.questionNodeDiv,
          ...{
            border: `1px solid ${colorMap[borderAlert] || colorMap.default}`,
          },
        }}
      >
        {isQuestionnaire && mode !== "view" && (
          <img
            onDragEnd={(e) => hasQuestion?.length >= 2 && onDragEnd(e)}
            onDragEnter={(e) =>
              hasQuestion?.length >= 2 && onDragEnter(e, question.sequence)
            }
            onDragOver={(e) => hasQuestion?.length >= 2 && onDragOver(e)}
            onDrop={onSectionDrop}
            onDragStart={onSectionDropStart}
            alt="dragIcon"
            src={"/icons/drag_indicator.svg"}
            style={{
              ...AddQuestionnaireQuestionContainerStyle.dragIcon,
              ...{
                visibility: hasQuestion?.length >= 2 ? "visible" : "hidden",
              },
            }}
          />
        )}
        <div
          draggable={mode !== "view" && hasQuestion?.length >= 2}
          style={AddQuestionnaireQuestionContainerStyle.draggableDivStyle}
          key={question.sequence}
          onDragEnd={(e) => hasQuestion?.length >= 2 && onDragEnd(e)}
          onDragEnter={(e) =>
            hasQuestion?.length >= 2 && onDragEnter(e, question.sequence)
          }
          onDragOver={(e) => hasQuestion?.length >= 2 && onDragOver(e)}
          onDrop={onSectionDrop}
          onDragStart={onSectionDropStart}
        >
          {isQuestionnaire ? (
            <AddQuestionnaireQuestionContent
              mode={mode}
              question={question}
              questionsData={questionsData}
              setQuestionsData={setQuestionsData}
              indexKey={indexKey}
              hasQuestion={hasQuestion}
              addQuestionToSection={addQuestionToSection}
              showAddNewSection={hasQuestion.length - 1 === index}
            />
          ) : (
            <AuditQuestionnaireContainer
              question={question}
              evidenceInProgress={evidenceInProgress}
              setEvidenceInProgress={setEvidenceInProgress}
              mode={isAudit ? "edit" : "view"}
              setBorderAlert={setBorderAlert}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default AddQuestionnaireQuestionContainer;
